import { YmParams } from 'shared/typings';

import { getDateTimeGreenwich } from './ym';

export const getYmParams = (): YmParams => {
	return {
		datetime_event: getDateTimeGreenwich(),
		event_type: 'click_button',
		keycloak_id: localStorage.getItem('user_id') || 'undefined',
		page_screen: undefined,
		telerev_user_id: localStorage.getItem('user_id') || 'undefined',
	};
};
